import './index.scss'

import React from 'react'
import { Input, Tooltip, Modal, Button, Tabs, message } from 'antd'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import moment from 'moment'
import Cards from 'react-credit-cards'

import { refresh_profile } from '../../../actions/auth'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import SaveButton from '../../../components/Shared/SaveButton'
import LoadingSpinner from '../../../components/Shared/LoadingSpinner'
import PaymentForm from '../../../components/Billing/PaymentForm'
import BillingForm from '../../../components/Billing/BillingForm'
import AddCardForm from '../../../components/Billing/AddCardForm'
import VisaLogo from '../../../assets/img/icon/visa.png'
import MasterCardLogo from '../../../assets/img/icon/mastercard.png'
import AddCreditCard from '../AddCreditCard'

const CardItem = ({ name, exp, number, isDefault, type }) => {
    let logo = <span />
    if (type === 'visa')
        logo = <img className="issuer-logo" alt="" src={VisaLogo} />
    else if (type === 'mastercard')
        logo = <img className="issuer-logo" alt="" src={MasterCardLogo} />

    return (
        <div className="card-item">
            {logo}
            <div>
                <h3 className={isDefault ? 'card-name-default' : 'card-name'}>
                    {name}
                </h3>
                <p className="card-desc">{number}</p>
                {isDefault && <p>future payments will use this card</p>}
            </div>
            {isDefault ? (
                <Button className="card-btn" type="primary">
                    Default Card
                </Button>
            ) : (
                <Button className="card-btn">Pay With This Card</Button>
            )}
            <Button shape="circle" icon="delete" />
        </div>
    )
}

const CardsList = ({ cards, defaultCard }) => (
    <div className="cards-list">
        {cards.map(card => (
            <CardItem
                name={card.name}
                exp={card.exp}
                number={card.number}
                key={card.number}
                isDefault={card.number === defaultCard}
                type={card.type}
            />
        ))}
    </div>
)

class BillingDetails extends React.Component {
    constructor() {
        super()

        this.state = {
            loading: true,
            addCardLoading: false,
            creditCard: null,
            payments: [],
            subscriptionId: null,

            billing_modal_visible: false,
            focused: '',
            billing_loading: false,

            billing: {
                number: '',
                firstName: '',
                lastName: '',
                exp: '',
                cvc: '',
                focused: '',
            },
            cards: [],
            defaultCard: '1234 1234 1234 1234',
        }

        this.cardImgs = {
            visa: VisaLogo,
            mastercard: MasterCardLogo,
        }
    }

    componentDidMount() {
        this.refreshCards()
    }

    refreshCards() {
        this.setState({ loading: true })

        CloudFlyerAPI.billing.fetchPaymentProfiles().then(({ data }) => {
            const newData = data['billing_payment_profiles'].map(
                ({ payment_profile }) => {
                    const profile = payment_profile
                    return {
                        name: `${profile.last_name} ${profile.first_name}`,
                        exp: `${profile.expiration_month}/${
                            profile.expiration_year
                        }`,
                        number: profile.masked_card_number,
                        type: profile.card_type,
                    }
                }
            )
            this.setState({ loading: false, cards: newData })
        })
    }

    filterPayments(payments) {
        const allowedKeys = [
            'subscription_product_change',
            'payment_success',
            'subscription_state_change',
        ]
        return payments.filter(entry => allowedKeys.includes(entry.event.key))
    }

    on_focus = target => {
        this.setState({
            focused:
                target.name === 'firstName' || target.name === 'lastName'
                    ? 'name'
                    : target.name,
        })
    }

    on_addcard_focus = target => {
        this.setState({
            billing: {
                ...this.state.billing,
                focused:
                    target.name === 'firstName' || target.name === 'lastName'
                        ? 'name'
                        : target.name,
            },
        })
    }

    on_billing_change = target => {
        const billing = { ...this.state.billing }

        if (target.name === 'number') {
            billing[target.name] = target.value.replace(/ /g, '')
        } else if (target.name === 'expiry') {
            billing[target.name] = target.value.replace(/[ \/]/g, '')
        } else {
            billing[target.name] = target.value
        }

        this.setState({
            billing: billing,
        })
    }

    billing_callback = (type, isValid) => {
        this.setState({ billing_valid: isValid })
    }

    on_cancel_billing = () => {
        this.setState({ billing_modal_visible: false })
    }

    on_save_billing = () => {
        let $this = this
        $this.form.validateFields((err, values) => {
            if (err) {
                return message.error('Please fill required fields')
            }

            $this.setState({ billing_loading: true })

            const { name, number, expiry, cvc } = values
            let { email, first_name, last_name } = $this.props.user

            let subscription = {
                customer_subscription: {
                    subscription: {
                        product_handle: 'CloudFlyer-free',
                        coupon_code: '',

                        customer_attributes: {
                            first_name: first_name,
                            last_name: last_name,
                            email: email,
                        },

                        credit_card_attributes: {
                            full_number: number,
                            expiration_month: expiry.split('/')[0],
                            expiration_year: expiry.split('/')[1],
                            billing_address: '',
                            billing_city: '',
                            billing_state: '',
                            billing_country: 'USA',
                            billing_zip: '',
                        },
                    },
                },
            }

            CloudFlyerAPI.billing.subscriptions
                .new_customer(subscription)
                .then(() => {
                    $this.setState(
                        {
                            billing_loading: false,
                            billing_modal_visible: false,
                        },
                        () => {
                            message.success('Subscribed successfully')
                            $this.props.refresh_profile()
                        }
                    )
                })
                .catch(function(err) {
                    $this.setState({ billing_loading: false }, () =>
                        $this.props.refresh_profile()
                    )

                    if ((err.response || {}).data || {}) {
                        if (((err.response || {}).data || {}).chargify_errors) {
                            return message.error(
                                ((err.response || {}).data || {})
                                    .chargify_errors[0]
                            )
                        }
                        message.error(((err.response || {}).data || {}).message)
                    } else {
                        message.error(err.message)
                    }
                })
        })
    }

    save_ref = form => {
        this.form = form
    }

    on_save = () => {
        const cc = this.state.billing
        this.setState({ addCardLoading: true })
        CloudFlyerAPI.billing
            .addCreditCard({
                full_number: cc.number,
                first_name: cc.firstName,
                last_name: cc.lastName,
                expiration_month: cc.expiry.slice(0, 2),
                expiration_year: cc.expiry.slice(2, 4),
                billing_address: '',
                billing_city: '',
                billing_state: '',
                billing_country: '',
                billing_zip: '',
            })
            .then(res => {
                message.success('Credit Card Added Successfully')
                this.setState({
                    addCardLoading: false,
                    billing: {
                        number: '',
                        firstName: '',
                        lastName: '',
                        exp: '',
                        cvc: '',
                        focused: '',
                    },
                })
                this.refreshCards()
            })
            .catch(res => {
                this.setState({ addCardLoading: false })
                message.error('Could not add Credit Card')
            })
    }

    render() {
        const {
            history,
            user: { role = {} },
        } = this.props
        const {
            creditCard,
            payments,
            subscriptionId,
            loading,
            showCloseAccountModal,
        } = this.state
        const {
            first_name,
            last_name,
            masked_card_number,
            expiration_month,
            expiration_year,
            name,
            expiry,
            cvc,
        } = creditCard ? creditCard : {}

        const number = masked_card_number
            ? masked_card_number.replace(/X/g, '0').replace(/-/g, '')
            : '0000000000000'

        const {
            addCardLoading,
            billing_modal_visible,
            focused,
            billing_loading,
            billing_valid,
            cards,
            defaultCard,
        } = this.state
        const {
            firstName: firstName,
            lastName: lastName,
            number: billing_number,
            expiry: billing_expiry,
            cvc: billing_cvc,
        } = this.state.billing

        if (loading) {
            return <LoadingSpinner />
        }

        return (
            <div className="billing-container">
                <div className="payment-methods">
                    <div>
                        <h2>Existing Cards</h2>
                        {cards.length ? (
                            <CardsList
                                cards={cards}
                                defaultCard={defaultCard}
                            />
                        ) : (
                            <div className="no-credit-card">
                                No Credit Cards Added
                            </div>
                        )}
                    </div>
                    <div>
                        <h2>Add New Card</h2>
                        <AddCardForm
                            title="Add New Card"
                            loading={addCardLoading}
                            on_save={this.on_save}
                            on_cancel={() => console.log('canceling ..')}
                            firstName={firstName}
                            lastName={lastName}
                            number={billing_number}
                            expiry={billing_expiry}
                            cvc={billing_cvc}
                            focused={this.state.billing.focused}
                            callback={this.billing_callback}
                            on_focus={this.on_addcard_focus}
                            on_change={this.on_billing_change}
                            valid={billing_valid}
                        />
                    </div>
                </div>

                {/* <div className="credit-card round-corner">
          <div className="header">
          <h5>Payment Method</h5>
          {creditCard ? (
          <button>
          <span>{creditCard.card_type}</span>
          </button>
          ) : null}
          </div>

          {role.title !== "Owner" ? (
          <p>Payment Method is managed by the organization owner.</p>
          ) : (
          <div>
          {creditCard ? (
          [
          <div className="card-info" key={"card-info"}>
          <Cards
          number={number}
          name={first_name ? first_name + " " + first_name : "name"}
          expiry={
          (expiration_month
          ? expiration_month +
          "" +
          expiration_year.toString().substring(2)
          : "##/##") || "##/##"
          }
          cvc={cvc ? cvc : "###"}
          />
          </div>,
          <div className="owner-info" key={"owner-info"}>
          <h5>Full Info</h5>
          <div className="info-row">
          <p>Billing Name</p>
          <p>
          {creditCard.first_name + " " + creditCard.last_name}
          </p>
          </div>
          <div className="info-row">
          <p>Billing Address</p>
          <p>{creditCard.billing_address}</p>
          </div>
          <div className="info-row">
          <p>Billing State</p>
          <p>{creditCard.billing_state}</p>
          </div>
          <div className="info-row">
          <p>Billing Country</p>
          <p>{creditCard.billing_country}</p>
          </div>
          <div className="info-row">
          <p>Billing Zip</p>
          <p>{creditCard.billing_zip}</p>
          </div>
          <div className="action-btns">
          {creditCard ? (
          <SaveButton
          onClick={() =>
          history.push(
          "/billing/addcreditcard/" + subscriptionId
          )
          }
          >
          Edit Card
          </SaveButton>
          ) : null}
          <SaveButton
          onClick={() =>
          this.setState({ showCloseAccountModal: true })
          }
          >
          Close Account
          </SaveButton>
          </div>
          </div>
          ]
          ) : (
          <div className={"empty-billing-info"}>
          <Button
          onClick={() =>
          this.setState({ billing_modal_visible: true })
          }
          >
          Add Billing Info
          </Button>
          </div>
          )}
          </div>
          )}
          </div>
        */}

                {/* <div className="payment-list round-corner">
          <div className="header">
          <h5>Your Payments</h5>
          <Input.Search placeholder="Search a transaction" />
          </div>
          {payments.map(({ event }) => (
          <div className="payment-item" key={event.id}>
          <div className="payment-date">
          <p>{moment(event.created_at).format("ddd - MMM D YYYY")}</p>
          </div>
          <div className="payment-price">
          <p>
          <span>$</span> 00.00 USD
          </p>
          </div>
          <Tooltip title={event.message}>
          <div className="payment-desc">
          <p>{event.key}</p>
          </div>
          </Tooltip>
          </div>
          ))}
          </div>
        */}
                {/* <Modal
                    visible={showCloseAccountModal}
                    onCancel={() =>
                    this.setState({ showCloseAccountModal: false })
                    }
                    footer={[
                    <Button
                    key="cancel"
                    onClick={() =>
                    this.setState({ showCloseAccountModal: false })
                    }>
                    Cancel
                    </Button>,
                    <Button
                    key="confirm"
                    type="danger"
                    onClick={this.handleCloseAccount}>
                    Submit
                    </Button>,
                    ]}>
                    <p>content goes here</p>
                    </Modal>

                    <PaymentForm
                    title={'Add your billing info'}
                    ref={this.save_ref.bind(this)}
                    visible={billing_modal_visible}
                    loading={billing_loading}
                    name={billing_name}
                    number={billing_number}
                    expiry={billing_expiry}
                    cvc={billing_cvc}
                    focused={focused}
                    on_cancel={this.on_cancel_billing}
                    on_save={this.on_save_billing}
                    on_focus={this.on_focus}
                    on_change={this.on_billing_change}
                    callback={this.billing_callback}
                    /> */}
            </div>
        )
    }
}

export default withRouter(
    connect(
        ({ auth }) => {
            return {
                user: auth.user,
            }
        },
        dispatch =>
            bindActionCreators({ refresh_profile: refresh_profile }, dispatch)
    )(BillingDetails)
)
